import React from 'react';
import PropTypes from 'prop-types';
import { ConnectedAirportSelectorDesktop } from '../../AirportSelector';
import { ConnectedSegmentDeparture } from '../Segment/SegmentDeparture';
import { EntryPoint, FieldType, LegType } from '../../../models';
import { LocationAutocompleteSource } from '../../LocationAutocomplete/LocationAutocompleteSource';
import { useSegmentContext } from '../Segment/SegmentManager/Context';

export const DepartureDesktop = ({ fieldFocused, onChangeFocus }) => {
    const { segment } = useSegmentContext();
    const { id } = segment;

    const getDepartureAirportSelectorSources = () => {
        const departureOrArrival = LegType.DEPARTURE;
        const locationAutocomplete = LocationAutocompleteSource({
            departureOrArrival,
            activeProduct: EntryPoint.HOTELS
        });
        return [locationAutocomplete];
    };

    return (
        <ConnectedSegmentDeparture segmentId={id}>
            {({ error, setValue, value, isDisabled }) => (
                <ConnectedAirportSelectorDesktop
                    departureOrArrival={LegType.DEPARTURE}
                    validationError={error}
                    value={value}
                    setValue={setValue}
                    sources={getDepartureAirportSelectorSources()}
                    onChangeFocus={onChangeFocus}
                    focus={fieldFocused === FieldType.DEPARTURE}
                    isDisabled={isDisabled}
                />
            )}
        </ConnectedSegmentDeparture>
    );
};

DepartureDesktop.propTypes = {
    fieldFocused: PropTypes.string,
    onChangeFocus: PropTypes.func.isRequired,
};

DepartureDesktop.defaultProps = {
    fieldFocused: null,
};
